import {
  toggleNewbuildingBrokerOfferBookingExistsModal,
  setNewbuildingBrokerOfferBookingLoading,
  toggleNewbuildingBrokerProfessionalAccessBlockedModal,
} from 'shared/actions/newbuildingBrokerOfferBooking';
import { selectUser } from 'shared/selectors';
import { canMakeNewbuildingBrokerRequest } from 'shared/services/canMakeNewbuildingBrokerRequest';

import type { IThunkActionCreator } from 'shared/store';

export const checkBookingExists =
  (navigationHandler: () => void): IThunkActionCreator<Promise<void>> =>
  async (dispatch, getState, context) => {
    const user = selectUser(getState());

    if (user?.isAgent || user?.isProfi) {
      dispatch(toggleNewbuildingBrokerProfessionalAccessBlockedModal(true));

      return;
    }

    try {
      dispatch(setNewbuildingBrokerOfferBookingLoading(true));

      // TODO: В CD-268729 убрать проверку при выигрыше эксперимента.
      if (!user?.isAuthenticated) {
        navigationHandler();

        return;
      }

      const canMakeRequest = await canMakeNewbuildingBrokerRequest(context);

      if (canMakeRequest) {
        navigationHandler();
      } else {
        dispatch(toggleNewbuildingBrokerOfferBookingExistsModal(true));
        dispatch(setNewbuildingBrokerOfferBookingLoading(false));
      }
    } catch (error) {
      // Страница бронирования проверит на своей стороне.
      navigationHandler();
    }
  };
